import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Organicé mi estudio en una tarde. Los scripts de WhatsApp me ahorran horas de idas y vueltas con clientas cada semana.',
  name: 'Mariela G.',
  location: 'Córdoba',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/c50a188e-f471-42ab-97d4-2f0896e99672.jpg'
}, {
  quote: 'El protocolo anti-cancelaciones por fin funciona. El tomo de finanzas es el hit para entender cuánto gano de verdad cada mes.',
  name: 'Laura P.',
  location: 'Rosario',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/fc42f124-2ef1-4024-a260-be5850ce7b7b.jpg'
}, {
  quote: 'Mis ganancias no dejan de incrementar. El Tomo de Publicidad Low-Cost vale absolutamente cada peso que pagué.',
  name: 'Romina M.',
  location: 'Buenos Aires',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/ebbbbf0d-83b8-4715-bc39-8797da767918.jpg'
}];
export function Testimonials() {
  return <section aria-label="Testimonios" className="bg-ink" data-id="element-143" data-mp="h5oqhd9wga8h">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20 pt-[47px]" data-id="element-144" data-mp="h8ax9aoyulpn">
        <h2 className="text-center font-display text-3xl font-black text-white sm:text-4xl" data-id="element-145" data-mp="m6m5jgzm4o5r">
          💬 Qué dicen quienes ya lo aplicaron
        </h2>
        <div className="mt-10 grid w-full grid-cols-1 gap-5 sm:mt-12 md:grid-cols-3 md:gap-6" data-id="element-146" data-mp="c6bt3ylejkrn">
          {testimonials.map((t, i) => <motion.figure key={t.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="flex min-h-[230px] flex-col rounded-2xl border border-white/10 bg-ink-2 p-6 sm:min-h-[250px]" data-id="element-147" data-mp="zxha4h32wj3j" data-mpi={i}>
              <div className="flex gap-0.5 text-gold" data-id="element-148" data-mp="1ivk3f82nt275">
                {Array.from({
              length: 5
            }).map((_, k) => <StarIcon key={k} className="h-4 w-4 fill-current" data-id="element-149" data-mp="1nma80j39h10s" data-mpi={k} />)}
              </div>
              <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-white/80" data-id="element-150" data-mp="1xiitozps5qka">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-white/10 pt-4" data-id="element-151" data-mp="1sjpdgzj3zlgf">
                <img src={t.img} alt={t.name} className="h-11 w-11 rounded-full object-cover ring-2 ring-rose/40" data-id="element-152" data-mp="1ofhnkz0wzzgm" />
                <div data-id="element-153" data-mp="1jkc6cdigj8yv">
                  <div className="text-sm font-bold text-white" data-id="element-154" data-mp="1eiv4aeo8lggp">{t.name}</div>
                  <div className="text-xs text-white/50" data-id="element-155" data-mp="1ekzhxobxttu6">📍 {t.location}</div>
                </div>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}